import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuthStore from '@/store/authStore';
import { authAPI } from '@/services/api';
import { fetchCsrfToken } from '@/services/api';

const useAuthCheck = () => {
  const { setUser, logout, isAuthenticated } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    // Ne vérifier l'authentification que sur les pages protégées
    const publicPaths = ['/auth', '/'];
    const isPublicPath = publicPaths.some(path => location.pathname.startsWith(path));

    if (isPublicPath) {
      return; // Ne pas vérifier l'authentification sur les pages publiques
    }

    const checkAuth = async () => {
      try {
        // Si l'utilisateur est déjà authentifié, récupérer le token CSRF
        if (isAuthenticated) {
          await fetchCsrfToken();
        }

        // Vérifier si l'utilisateur est authentifié via la session
        const response = await authAPI.me();
        if (response.data) {
          setUser(response.data);
          // Récupérer le token CSRF après authentification réussie
          await fetchCsrfToken();
        }
      } catch (error) {
        console.log('User not authenticated:', error.response?.status);
        // Si 401 ou 403, l'utilisateur n'est pas authentifié
        // L'intercepteur axios gérera la redirection et le nettoyage
        if (error.response?.status === 401 || error.response?.status === 403) {
          // Nettoyer le store localement aussi
          logout();
        }
      }
    };

    checkAuth();
  }, [setUser, logout, location.pathname, isAuthenticated]);

  return null;
};

export default useAuthCheck;
